module.exports = __webpack_public_path__ + "img/glry-4.d0cc2d07.jpg";